import { IMemberPicture, MembersClient } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import delay from "Utils/delay";
import { useEffect, useState } from "react";

export interface UserPictureCache {
   [memberId: Guid]: Promise<string | undefined>
}

let runningLoop: Promise<void> | undefined;
const queue: { memberId: Guid, resolve(url: string | undefined): void }[] = [];

async function startLoop(membersClient: MembersClient) {
   while (queue.length > 0) {
      //throttle: give .5s to collect requests
      await delay(500);

      const localQueue = [...queue];
      queue.length = 0;

      let items: IMemberPicture[] = [];
      try {
         items = await membersClient.getPictures(localQueue.map(x => x.memberId))
      }
      catch {

      }

      for (let index = 0; index < localQueue.length; index++) {
         const element = localQueue[index];

         element.resolve(items.find(x => x.memberId === element.memberId)?.url);
      }
   }
}

function queueRequest(membersClient: MembersClient, memberId: Guid): Promise<string | undefined> {
   const result = new Promise<string | undefined>(resolve => {
      queue.push({ memberId, resolve });
   });

   if (runningLoop == null) {
      runningLoop = startLoop(membersClient).then(() => runningLoop = undefined);
   }

   return result;
}

export function useMemberPicture(cache: UserPictureCache, memberId?: Guid) {
   const membersClient = useApiClient(MembersClient);

   const [pictureUrl, setPictureUrl] = useState<string>();
   useEffect(() => {
      if (memberId) {
         const promise = (cache[memberId] ??= queueRequest(membersClient, memberId));

         const abortController = new AbortController();
         promise.then(url => { abortController.signal.aborted || setPictureUrl(url); });

         return () => abortController.abort();
      }
   }, [cache, memberId]);

   return pictureUrl;
}
